module.exports = __webpack_public_path__ + "static/media/boy1.df4b69f9.jpeg";